import React from 'react';
import { useState } from 'react';
import { isInvalidPriceChar } from '../../utils/PriceValidator';
import { toast } from 'react-toastify';
import SpecialListCalendar from './SpecialListCalendar';
import { AddKeyInputField } from '../../pages/bots/listings/[id]';

import dayjs from 'dayjs';
import badMutable from 'dayjs/plugin/badMutable';
import localizedFormat from 'dayjs/plugin/localizedFormat';
dayjs.extend(badMutable);
dayjs.extend(localizedFormat);

const AddSpecial = ({ saveS, showAdd, startDate, endDate }) => {
  const [sDate, setSDate] = useState(dayjs(startDate));
  const [sPrice, setSPrice] = useState(null);

  const onPriceInput = (e: any) => {
    if (isInvalidPriceChar(e.key)) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  };

  return (
    <div className="flex flex-col bg-gray-100 rounded-md my-2 p-2">
      <div className="flex flex-col justify-start">
        <label
          htmlFor="price"
          className="block text-sm font-medium text-gray-700 pt-4"
        >
          Set your date
        </label>
        <div className="md:w-56">
          <SpecialListCalendar
            startDate={startDate}
            endDate={endDate}
            sel={sDate}
            setSel={setSDate}
          />
        </div>
      </div>
      <div className="flex flex-col justify-start mt-4">
        <div>
          <div>
            <label
              htmlFor="price"
              className="block text-sm font-medium text-gray-700"
            >
              Special Price for {sDate.format('L')}
            </label>

            <div className="mt-1 relative rounded-md shadow-sm w-1/2">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <span className="text-gray-500 sm:text-sm">$</span>
              </div>
              <AddKeyInputField
                type="number"
                name="price"
                id="price"
                placeholder="5.00"
                value={sPrice}
                aria-describedby="price-currency"
                onKeyPress={onPriceInput}
                onChange={(e: any) => setSPrice(e.target.value)}
              />

              <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                <span className="text-gray-500 sm:text-sm" id="price-currency">
                  USD
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="justify-end mt-4 flex">
        <div className="space-x-2">
          <button
            onClick={() => showAdd(false)}
            className="bg-white py-1 px-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Cancel
          </button>
          <button
            onClick={() => {
              sPrice < 5
                ? toast(
                    'Please enter a valid price before continuing. Minimum value must be $5',
                    { type: 'error' },
                  )
                : saveS(sDate, sPrice);
            }}
            className=" inline-flex justify-center py-1 px-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-500 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddSpecial;
